export function isTruthyDebugValue(value) {
  return value === true
    || value === 1
    || value === '1'
    || value === 'true'
    || value === 'yes'
    || value === 'on';
}

export function isDebugFlagEnabled(configKeys = []) {
  const config = document.kvConfig || {};

  return configKeys.some(key => isTruthyDebugValue(config[key]));
}
